
// Small Snippet to update emos_privacy flag, depending on consent settings.
window.addEventListener( 'load_triggered_script.tao', function( ev ) {
	const detail = ev.detail || [];

	if ( 'localStorage' in window ) {
		if ( detail.includes( '1' ) || detail.includes( '2' ) ) {
			window.localStorage.setItem( 'emos_privacy', '3' );
		} else {
			window.localStorage.removeItem( 'emos_privacy' );
		}
	}
} );
